import React , { useState } from "react";
import _ from "lodash";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Row,
    Col
} from "reactstrap";
// core components
import { withTranslation } from "../../../../i18n";
import { useForm } from "react-hook-form"
// import CommonFields from "../fields/shared/CommonFields";
import UnitFields from "../fields/";
import UIDs from "../../../../UIDs";
//import { helpers } from "chart.js";
import { ImageField } from "../fields/types";
import MessageBox from "../../../../components/ui/MessageBox";
import { Sticky } from "react-sticky";
import { LocalizableTextField } from "../fields/types";
import * as Helper from "../../../../utils/Helper";

const uid = UIDs.screens.admin.unit.forms.simplebatchunitform;

let t;

function CommonFields({ formMethods, values, resourceId, isCompositeUnit, unitType }) {
    const { register, errors, clearError } = formMethods
    const { duration, cover, title, renderCover } = values;
    const fieldsForImage = {
        imagePath: { name: "cover", value: cover, label: t("cover") },
        registerPayload: { required: false }
    }

    const fieldsForTitle = {
        text: {
            name: "title", label: unitType==="POKA2" ? t("titleQuestion") : t("title"), value: title,
            registerPayload: {
                required: false
            }
        },
    };

    return (        
        <>  
            <Row style={{ marginBottom: 0}}>
                <Col>
                    <LocalizableTextField formMethods={formMethods} fields={fieldsForTitle}
                                          placeholder={' '}
                                          isSimpleBatchForm={true}/>
                </Col>
            </Row>
        </>
    );
}

const SimpleBatchUnitForm = (props) => {
    t = props.t;

    const hasCommonFieldsUnits = ['POKA2'];

    //form hook helper func
    const formMethods = useForm();
    if (!formMethods.oldSetValue) {
        // hook setValue方法, 当组件调用setValue设置表单数据时, 能通知外部数据已更新
        formMethods.onChange = props.onChange;
        formMethods.oldSetValue = formMethods.setValue;
        formMethods.setValue = (key, value, noChange) => {
            formMethods.oldSetValue(key, value);
            if (!noChange) {
                if (props.onChange) {
                    props.onChange(key, value);
                }
            }
        };
    }

    const { unitType, formData, commonFieldValues, id } = props.data;
    if (props.onForm) {
        props.onForm(id, formMethods);
    }

    const isCompositeUnit = ('CP' === unitType);
    const EditFields = UnitFields[SimpleBatchUnitForm.toFieldTypeName(unitType)];

    const hasCommonFields = (hasCommonFieldsUnits.indexOf(unitType) >= 0);

    const onSave = newFormData => {
        var buildFieldsData = EditFields.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = EditFields.WrappedComponent.buildFieldsData;
        }

        let fieldsData = {};
        try {
            fieldsData = buildFieldsData(newFormData)
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        if (fieldsData.data && _.isPlainObject(fieldsData.data)){
            if (!isCompositeUnit) {
                fieldsData.data = {
                    ...fieldsData.data,
                    title: Helper.combineTranslation(newFormData, "title"),
                }
            }
        }

        let duration = newFormData.duration;
        if (isCompositeUnit) {
            // 复合单元duration为所有子单元的duration相加
            duration = 0;
            fieldsData.data.units.forEach((subUnit) => {
                duration += parseInt(subUnit.duration);
            });
        }

        let submitData = {
            ...fieldsData,
            commonFieldValues: {
                duration: duration,
                cover: newFormData.cover,
            }
        }

        props.onSave(submitData);
    };

    const onSaveAndCreate = newFormData => {
        var buildFieldsData = EditFields.buildFieldsData;
        if (!buildFieldsData) {
            // due to translation wrapper
            buildFieldsData = EditFields.WrappedComponent.buildFieldsData;
        }

        let fieldsData = {};
        try {
            fieldsData = buildFieldsData(newFormData)
        } catch (e) {
            MessageBox.danger({ text: e.message, duration: 5000 });
            return;
        }

        if (fieldsData.data && _.isPlainObject(fieldsData.data)){
            fieldsData.data = {
                ...fieldsData.data,
                title: Helper.combineTranslation(newFormData, "title"),
            }
        }

        let submitData = {
            ...fieldsData,
            commonFieldValues: {
                duration: newFormData.duration,
                cover: newFormData.cover,
            }
        }

        props.onSaveAndCreate(submitData);
    };
    
    const { hotkeysHandler } = props;

    const formHotKeysHandler = e => {
        e = e || window.event;
        if (e.keyCode === 83 && e.altKey) {//alt+s,alt+S
            formMethods.handleSubmit(onSave)()
        }
        if (e.keyCode === 67 && e.altKey) {//alt+s,alt+S
            formMethods.handleSubmit(onSaveAndCreate)()
        }
        if (e.keyCode === 82 && e.altKey) {//alt+r,alt+R
            formMethods.reset()
        }
        if (e.keyCode === 81 && e.altKey) {//alt+q,alt+Q
            hotkeysHandler.CANCEL();
        }
    };

    const bindHotkeys = setInterval(() => {
        const unitForm = document.getElementById("unitForm");
        if (unitForm) {
            const inputs = unitForm.querySelectorAll("input,textarea");
            Array.from(inputs).map(e => e.onkeydown = formHotKeysHandler)
            clearInterval(bindHotkeys);
        }
    }, 100);

    window.onkeydown = formHotKeysHandler;

    const [state_hideHeader, setstate_hideHeader] = useState(false);
    return (
        <form id="unitForm" onChange={props.onChange}>
            <Card className="shadow">
                <CardBody>
                    {hasCommonFields ?
                     (<CommonFields formMethods={formMethods} values={commonFieldValues} resourceId={props.resourceId} isCompositeUnit={isCompositeUnit} unitType={unitType}  />) : null}
                    <EditFields formMethods={formMethods}
                                data={formData} resourceId={props.resourceId}
                                isSimpleBatchForm={true} onHideHeader={(hide) => setstate_hideHeader(hide)}/>
                </CardBody>
            </Card>
        </form>
    );
}

SimpleBatchUnitForm.toFieldTypeName = function(unitType) {
    switch (unitType) {
    case 'POKA3':
        return 'POKA3Simple';

    case 'POKA4':
        return 'POKA4Simple';

    case 'PSKA5':
        return 'PSKA5Simple';

    case 'PSSD2_AUDIO':
        return 'PSSD2Audio';
    }

    return unitType;
}

export default withTranslation(uid)(SimpleBatchUnitForm);
